<template>
  <template v-if="(list?.data?.results || []).length > 0">
    <h3>{{ $t('chan-pin-geng-xin-shi-pin') }}</h3>
    <div class="video-grid relative">
      <a-button
        v-if="(list?.data?.results || []).length > 8"
        type="link"
        class="more-btn flex justify-center items-center cursor-pointer"
        @click="more = !more"
      >
        {{ !more ? $t('zhan-kai-quan-bu') : $t('shou-qi-quan-bu') }}
        <iconpark-icon :name="!more ? 'arrowright' : 'arrowdown'" size="16"></iconpark-icon>
      </a-button>

      <div
        v-for="(item, index) in displayList"
        :key="index"
        class="video-item"
        :style="{ backgroundImage: `url(${transformImage(item.cover_url)})` }"
        @click="
          () => {
            currentDisplayIndex = index;
            trackEvent(TRACK_EVENT.CLICK_UPDATE_LOG, {
              title: item.title,
              source: SOURCE.NEWS,
            });
          }
        "
      >
        <div class="common">{{ $t('you-yan') }} | {{ $t('chan-pin-ri-zhi') }}</div>
        <div :class="['title font-bold', `type-${index % 3}`]">
          {{ item.title }}
        </div>
        <div class="time">
          {{ timeFormat(item.iteration_time, $t('mm-yue-dd-ri-hhmm')) }}
        </div>
      </div>
    </div>
  </template>

  <a-modal
    :open="!!currentDisplayUpdate"
    :footer="null"
    width="680px"
    class="update-video-modal"
    @cancel="currentDisplayIndex = undefined"
  >
    <div
      class="video"
      :style="{
        backgroundImage: `url(${getFeUrl('/youyan-platform/jpeg/video-update-log-bg.jpeg')})`,
        backgroundSize: 'cover',
      }"
    >
      <div class="inner">
        <iconpark-icon
          v-if="currentViewVideoIndex > 0"
          name="arrow-left"
          class="switch-left"
          size="40"
          @click="currentViewVideoIndex -= 1"
        ></iconpark-icon>
        <iconpark-icon
          v-if="currentViewVideoIndex < currentDisplayUpdate?.videos.length - 1"
          name="arrow-right"
          class="switch-right"
          size="40"
          @click="currentViewVideoIndex += 1"
        ></iconpark-icon>
        <VideoPlayer
          class="video-player"
          :poster="currentDisplayUpdate?.cover_url"
          :url="currentDisplayUpdate?.videos[currentViewVideoIndex]"
          @click="
            () => {
              trackEvent(TRACK_EVENT.CLICK_UPDATE_LOG_PLAY, {
                title: currentDisplayUpdate.title,
              });
            }
          "
        />
      </div>
    </div>
    <div class="detail">
      <div class="title">
        <span class="name">
          {{ currentDisplayUpdate?.title }}
        </span>
        <span class="time">
          ({{ timeFormat(currentDisplayUpdate?.iteration_time, $t('yyyy-nian-mm-yue-dd-ri')) }})
        </span>
      </div>
      <div class="detail-content" v-html="currentDisplayUpdate?.description" />
    </div>
    <div class="footer w-full flex justify-center items-center">
      <div class="flex-1 flex justify-end">
        <a-button
          :class="[
            'switch-btn',
            {
              enable: currentDisplayIndex > 0 && currentDisplayIndex < trueList.length,
            },
          ]"
          type="link"
          @click="switchPrev"
        >
          {{ prevVersion?.title }}
        </a-button>
      </div>
      <div class="flex justify-center w-[136px] mx-[17px]">
        <nuxt-link
          :href="currentDisplayUpdate?.link_url"
          @click="
            () => {
              trackEvent(TRACK_EVENT.CLICK_UPDATE_LOG_MORE, {
                source: SOURCE.NEWS,
              });
            }
          "
        >
          <a-button class="view" type="primary">
            {{ $t('cha-kan-wan-zheng-ri-zhi') }}
          </a-button>
        </nuxt-link>
      </div>
      <div class="flex-1 flex justify-start">
        <a-button
          :class="['switch-btn', { enable: currentDisplayIndex < trueList.length - 1 }]"
          type="link"
          @click="switchNext"
        >
          {{ nextVersion?.title }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
import { getProductUpdate } from '~/api/module/publicize';
import { useTime } from '~/hooks/useTime';
import VideoPlayer from '~/components/video-player/index.vue';

const { timeFormat } = useTime();

const { data: list } = useAsyncData(() =>
  getProductUpdate({
    page: 1,
    page_size: 100,
    many: 0,
  }),
);

const switchPrev = () => {
  currentDisplayIndex.value = currentDisplayIndex.value - 1;
};

const switchNext = () => {
  currentDisplayIndex.value = currentDisplayIndex.value + 1;
};

const currentDisplayIndex = ref();
const currentViewVideoIndex = ref(0);

const prevVersion = computed(() => {
  return list.value?.data?.results[currentDisplayIndex.value - 1];
});

const nextVersion = computed(() => {
  return list.value?.data?.results[currentDisplayIndex.value + 1];
});

const trueList = computed(() => {
  return list.value?.data?.results || [];
});

const displayList = computed(() => {
  return more.value ? trueList.value : trueList.value.slice(0, 8);
});

const currentDisplayUpdate = computed(() => {
  return trueList.value[currentDisplayIndex.value];
});

const more = ref(false);
</script>

<style lang="scss" global>
.update-video-modal {
  video {
    object-fit: cover;
  }
  .ant-modal-content {
    position: relative;
    padding: 0 !important;
    border-radius: 20px;
  }
  .ant-modal-body {
    overflow: hidden;
    border-radius: 20px;
  }
  .ant-modal-close {
    position: absolute !important;
    right: -44px !important;
    top: 0px !important;
    border: 1px solid #fff !important;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    svg {
      color: #fff !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.switch-left,
.switch-right {
  cursor: pointer;
  position: absolute;
  top: 30%;
}
.switch-left {
  left: 30px;
  z-index: 222;
}
.switch-right {
  right: 30px;
  z-index: 222;
}
.switch-btn {
  pointer-events: none;
  visibility: hidden;
  color: var(--text-1) !important;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
  &.enable {
    pointer-events: initial;
    visibility: visible;
  }
}
.update-video-modal {
  .video {
    height: 380px;
    width: 100%;
    background: linear-gradient(181.69deg, #dbc9fe 2.67%, #f0f1fe 65.58%);
  }

  .detail {
    height: 120px;
    padding: 20px 28px;
    overflow: auto;
    .title {
      font-size: 16px;
      font-weight: 600;
      line-height: 1;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .time {
        margin-left: 4px;
        font-size: 12px;
        font-weight: 400;
        opacity: 0.4;
      }
    }
  }
}

.footer {
  height: 76px;
  border-top: 1px solid #eceff2;
}

.view {
  height: 36px;
  width: 136px;
  border-radius: 8px;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.more-btn {
  position: absolute;
  right: 0;
  top: -40px;
  font-size: 14px;
  line-height: 1;
  color: var(--text-1);
  opacity: 0.6;
  &:hover {
    opacity: 0.9;
    color: var(--text-1);
  }
}

.video {
  padding: 16px 16px 0;
  .inner {
    height: 100%;
    width: 100%;
    padding: 4px 4px 0;
    background-color: rgba($color: #ffffff, $alpha: 0.4);
    border-radius: 10px 10px 0 0;
  }
  .video-player {
    border-radius: 10px 10px 0 0;
  }
}

.video-item {
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 162px;
  border-radius: 12px;
  background-size: cover;

  .common {
    font-size: 10px;
    color: #ffffff;
    opacity: 0.6;
    margin-bottom: 16px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 16px;
    &.type-2 {
      background: linear-gradient(270deg, #ffffff 0%, #c336f6 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &.type-1 {
      background: linear-gradient(270deg, #ffffff 0%, #05ffe2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &.type-0 {
      background: linear-gradient(270deg, #ffffff 0%, #05b0ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .time {
    border: 1px solid rgba($color: #ffffff, $alpha: 0.3);
    color: #ffffff;
    width: 110px;
    height: 32px;
    display: flex;
    align-items: center;
    border-radius: 18px;
    justify-content: center;
    font-size: 12px;
  }
}
</style>
